import { useTranslation } from "react-i18next"

const formatNumber: (value: number | string) => string = (value) => {
  const { t } = useTranslation()

  return value && t('number.default', { val: value })
}

export const useFormatNumber = () => {
  return {
    formatNumber
  }
}
